import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FALLBACK = [
  { id: "fb-0", url: "https://images.unsplash.com/photo-1618843479313-40f8afb4b4d8?w=800&auto=format", label: "Mercedes G-Wagon" },
  { id: "fb-1", url: "https://images.unsplash.com/photo-1552519507-da3b142c6e3d?w=800&auto=format", label: "Mercedes AMG" },
  { id: "fb-2", url: "https://images.unsplash.com/photo-1606664515524-ed2f786a0bd6?w=800&auto=format", label: "Lexus IS" },
  { id: "fb-3", url: "https://images.unsplash.com/photo-1590362891991-f776e747a588?w=800&auto=format", label: "Honda Civic" },
];

export default function Gallery() {
  const [images, setImages] = useState(FALLBACK);
  const [isReal, setIsReal] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${API}/gallery`);
        if (Array.isArray(data) && data.length > 0) {
          setImages(data.map((p) => ({ id: p.id, url: `${API}/gallery/file/${p.id}`, label: p.label || "" })));
          setIsReal(true);
        }
      } catch (e) {
        console.warn("Gallery fallback in use", e);
      }
    })();
  }, []);

  return (
    <section
      id="gallery"
      data-testid="gallery-section"
      className="relative py-20 lg:py-28 px-6 lg:px-12 bg-[#FDF9F3]"
    >
      <div className="max-w-7xl mx-auto">
        <div className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-4">
          <div>
            <div className="font-hand text-2xl text-[#A67F4E] mb-2">the work</div>
            <h2
              data-testid="gallery-title"
              className="font-serif text-4xl sm:text-5xl lg:text-6xl font-bold tracking-tight text-[#3D2E1C]"
            >
              Recent{" "}
              <span className="text-[#A67F4E] font-hand text-5xl sm:text-6xl italic">rides.</span>
            </h2>
          </div>
          {!isReal && (
            <p className="text-sm text-[#7A6A55] max-w-sm">
              Placeholder shots — real gallery coming soon.
            </p>
          )}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {images.map((img, i) => (
            <div
              key={img.id}
              className={`relative group overflow-hidden rounded-2xl border-2 border-[#E9DFCB] hover:border-[#D6B98D] aspect-square transition-all ${i % 3 === 0 ? "-rotate-1" : i % 3 === 1 ? "rotate-1" : ""} hover:rotate-0`}
            >
              <img
                src={img.url}
                alt={img.label || "Gallery photo"}
                data-testid={`gallery-image-${i}`}
                className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
              {img.label && (
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#3D2E1C]/90 to-transparent p-4 text-xs font-semibold text-[#FDF9F3]">
                  {img.label}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
